import React from 'react';
//import { Link } from 'react-router-dom';

function LandingPage() {
  return (
    <div className="relative flex h-auto min-h-screen w-full flex-col bg-background-light dark:bg-background-dark font-display text-text-primary overflow-x-hidden">
      <div className="layout-container flex h-full grow flex-col">
        <div className="px-4 flex flex-1 justify-center py-5">
          <div className="layout-content-container flex flex-col max-w-md flex-1">
            
            {/* Header */}
            <header className="flex items-center justify-center whitespace-nowrap px-4 py-3">
              <div className="flex items-center gap-2 text-text-primary">
                <div className="text-primary">
                  <svg className="size-8" fill="currentColor" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                    <path clipRule="evenodd" d="M24 4H42V17.3333V30.6667H24V44H6V30.6667V17.3333H24V4Z" fillRule="evenodd"></path>
                  </svg>
                </div>
                <h1 className="text-text-primary text-2xl font-bold leading-tight tracking-[-0.015em]">Kaka卡卡兒童超跑體驗店</h1>
              </div>
            </header>

            {/* Main Content */}
            <div className="flex flex-col items-center justify-center flex-1 text-center px-4">
              <div className="mb-8">
                <h2 className="text-4xl font-black text-text-primary mb-4">歡迎使用Kaka卡卡兒童超跑體驗店</h2>
                <p className="text-gray-500 dark:text-gray-400 text-lg">請使用正確的商戶連結來訪問體驗服務</p>
              </div>

              <div className="w-full max-w-sm">
                <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-lg border border-gray-200 dark:border-gray-700">
                  <h3 className="text-lg font-bold text-text-primary mb-4">如何使用</h3>
                  <div className="text-left space-y-3 text-sm text-gray-600 dark:text-gray-400">
                    <div className="flex items-start gap-2">
                      <span className="text-primary font-bold">1.</span>
                      <span>從商戶提供的專屬連結進入</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="text-primary font-bold">2.</span>
                      <span>選擇您需要的服務項目</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="text-primary font-bold">3.</span>
                      <span>選擇日期和時間</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="text-primary font-bold">4.</span>
                      <span>填寫聯絡資訊並完成體驗登記</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 text-sm text-gray-500 dark:text-gray-400">
                <p>連結格式範例：</p>
                <code className="bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded text-xs mt-1 inline-block">
                  https://booking.kakafd.com/your-merchant-name
                </code>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;